@if (data$ | async; as data) {
  <app-alerts />

  <app-admin-shipping-method-form
    [data]="data"
    (submitClickEvent)="handleSubmitSuccessEvent($event)" />
} @else {
  <app-spinner-filled />
}
